import React, {useState} from 'react';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../services/Firebase';

const Form = () => {
    
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        company: "",
        description: "",
        // createdAt: new Date()
        });

    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      
      setIsSubmitting(true); // Disable the button
      try {
        // Add timestamp before submitting
        await addDoc(collection(db, "contact"), {
            ...formData,
            createdAt: new Date(),
        });

        // Save form data to Firestore
        // await addDoc(collection(db, "contact"), formData);
        alert("Message submitted successfully!");
        setFormData({ fullName: "", email: "", description: "", company: "" }); // Reset form
        
      } catch (error) {
        // setIsSubmitting(false); // Disable the button
        console.error("Error submitting message: ", error);
        alert("Failed to submit the message!");
      }finally {
        setIsSubmitting(false); // Ensure button re-enables on success/failure
    }
    //   setIsSubmitting(false); // Re-enable the button after process
    };

    return (
        <>
        <div className="bg-[var(--kaizekblue)] p-6 sm:p-8 lg:p-12 xl:p-16">
            <div className="bg-[#403F85] p-4 sm:p-6 lg:p-8 xl:p-12 2xl:p-16 rounded-2xl lg:rounded-[1.25rem]">
                <div className="grid grid-cols-1 lg:grid-cols-3 sm:gap-4">
                    <div className="p-2 sm:p-4 lg:p-6 2xl:p-8 mb-4">
                        <h1 className="text-white font-symbol text-2xl sm:text-3xl lg:text-4xl xl:text-5xl leading-tight sm:pb-2 my-4">Start Your Project</h1>
                        <h1 className="font-symbol text-[var(--whitetext)] text-base sm:text-2xl">Let's discuss how we can help with your embedded systems and IoT needs</h1>
                    </div>
                    <div className="col-span-2 bg-white p-4 sm:p-8 lg:p-12 2xl:p-16 rounded-2xl lg:rounded-[1.25rem]">
                        <form className="mx-2 md:mx-8 lg:mx-20 xl:mx-24" onSubmit={handleSubmit}>
                            <div className='mb-4 md:mb-6'>
                                <label htmlFor="fullName" className="block text-sm md:text-base text-[var(--lightgray)]">
                                Your Name
                                </label>
                                <input
                                type="text"
                                id="fullName"
                                name="fullName"
                                    value={formData.fullName}
                                    onChange={handleChange}
                                    required
                                className="text-sm md:text-base mt-1 block bg-[var(--violetwhite)] border-[var(--powderblue)] border-[0.063rem] w-full px-4 py-2 rounded-lg sm:rounded-xl shadow-sm focus:border-[var(--kaizekblue)] focus:ring-[var(--kaizekblue)]"
                                />
                            </div>

                            <div className='mb-4 md:mb-6'>
                                <label htmlFor="email" className="block text-sm md:text-base text-[var(--lightgray)]">
                                Email Address
                                </label>
                                <input
                                autoComplete="email"
                                type="email"
                                id="email"
                                name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                className="text-sm md:text-base mt-1 block bg-[var(--violetwhite)] border-[var(--powderblue)] border-[0.063rem] w-full px-4 py-2 rounded-lg sm:rounded-xl shadow-sm focus:border-[var(--kaizekblue)] focus:ring-[var(--kaizekblue)]"
                                />
                            </div>

                            <div className='mb-4 md:mb-6'>
                                <label htmlFor="company" className="block text-sm md:text-base text-[var(--lightgray)]">
                                Company Name
                                </label>
                                <input
                                autoComplete="company"
                                type="text"
                                id="company"
                                name="company"
                                    value={formData.company}
                                    onChange={handleChange}
                                    required
                                className="text-sm md:text-base mt-1 block bg-[var(--violetwhite)] border-[var(--powderblue)] border-[0.063rem] w-full px-4 py-2 rounded-lg sm:rounded-xl shadow-sm focus:border-[var(--kaizekblue)] focus:ring-[var(--kaizekblue)]"
                                />
                            </div>

                            <div className='mb-4 md:mb-6'>
                                <label htmlFor="description" className="block text-sm md:text-base text-[var(--lightgray)]">
                                Describe your project or how we can help
                                </label>
                                <textarea
                                id="description"
                                rows="4"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                required
                                className="text-sm md:text-base mt-1 block bg-[var(--violetwhite)] border-[var(--powderblue)] border-[0.063rem] w-full px-4 py-2 rounded-lg sm:rounded-xl shadow-sm focus:border-[var(--kaizekblue)] focus:ring-[var(--kaizekblue)]"
                                />
                            </div>

                            <div className='place-self-center flex py-4 xl:py-8'>
                                <button disabled={isSubmitting} className="button-theme">
                                {isSubmitting ? "Submitting.." : "Submit Inquiry"}
                                </button>
                            </div>

                            <div className='place-items-center'>
                                <p className='text-center text-sm text-[var(--darkgray)]'>By submitting this form, you agree to our Terms & Conditions and acknowledge that we may collect and process your data as outlined in our Privacy Policy</p>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Form